<template>
  <ui-menu
    v-model="value"
    :items="menuListFiltered"
    :content-class="contentClass"
    eager
    :location="location"
    :offset="offset"
    @action="handleAction"
  >
    <template #activator="{ props }">
      <slot name="activator" :value="value" v-bind="{ props }" />
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useNavbarSupport } from '@/composables';

const props = withDefaults(
  defineProps<{
    listClass?: string;
    contentClass?: string;
    location?: string;
    offset?: [number, number];
    hiddenElements?: string[];
    hasCloseIntercom?: boolean;
  }>(),
  {
    listClass: '',
    contentClass: '',
    location: 'bottom start',
    hiddenElements: () => [],
    hasCloseIntercom: false,
  },
);

const emit = defineEmits<{
  (event: 'action', payload: unknown): void;
  (event: 'temporary-password'): void;
}>();

const value = ref(false);

const { menuListFiltered } = useNavbarSupport({
  hiddenElements: () => props.hiddenElements,
  hasCloseIntercom: () => props.hasCloseIntercom,
  onTemporaryPassword: () => emit('temporary-password'),
});

const handleAction = (event: unknown) => {
  value.value = false;
  emit('action', event);
};
</script>

<style lang="scss">
.navbar-support {
  &__list {
    .v-list-item {
      color: var(--color-graphite) !important;
      text-decoration: none;

      .ui-icon {
        font-size: 11px;
        padding-right: 5px;
        color: var(--color-graphite);
      }
    }
  }
}
</style>
